const BASE_PERIOD_OPTIONS = [
  { label: "Today", value: "Today" },
  { label: "This Week", value: "This Week" },
  { label: "This Month", value: "This Month" },
  { label: "This Year", value: "This Year" },
];

export const getPeriodOptions = (createdAt) => {
  const options = [...BASE_PERIOD_OPTIONS];

  if (!createdAt) {
    return options;
  }

  const createdYear = new Date(createdAt).getFullYear();
  const currentYear = new Date().getFullYear();

  if (Number.isNaN(createdYear) || createdYear >= currentYear) {
    return options;
  }

  for (let year = currentYear - 1; year >= createdYear; year -= 1) {
    options.push({ label: `${year}`, value: `${year}` });
  }

  return options;
};
